module.exports = __webpack_public_path__ + "assets/ic_heart-6f3016.svg";